import { baseApi } from "./baseApi";

const TICKET_BASE_URL = "/tickets";

export const ticketApi = baseApi.injectEndpoints({
  tagTypes: ["Ticket"],

  endpoints: (builder) => ({
    getTicketList: builder.query({
      query: (params) => ({ url: `${TICKET_BASE_URL}`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Ticket", _id })),
              { type: "Ticket", id: "LIST" },
            ]
          : [{ type: "Ticket", id: "LIST" }],
    }),

    getTicketListForVendorProfile: builder.query({
      query: (params) => ({ url: `${TICKET_BASE_URL}/vendorTickets`, params }),
      providesTags: (result) =>
        result?.data
          ? [
              ...result?.data?.map(({ _id }) => ({ type: "Ticket", _id })),
              { type: "Ticket", id: "LIST" },
            ]
          : [{ type: "Ticket", id: "LIST" }],
    }),

    getTicketDetail: builder.query({
      query: (id) => `${TICKET_BASE_URL}/${id}`,
      providesTags: (result, error, id) => [
        { type: "Ticket", id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    createTicket: builder.mutation({
      query: (payload) => ({
        url: `${TICKET_BASE_URL}`,
        method: "POST",
        body: payload,
      }),
      invalidatesTags: (result, error, { _id }) => [
        { type: "Ticket", id: _id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    updateTicket: builder.mutation({
      query: (payload) => {
        const { _id, ...body } = payload;

        return {
          url: `${TICKET_BASE_URL}/${_id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Ticket", _id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    // ticket responses
    addTicketResponse: builder.mutation({
      query: (payload) => {
        const { ticketId, ...body } = payload;

        return {
          url: `${TICKET_BASE_URL}/${ticketId}/responses`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Ticket", id: _id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    updateTicketResponse: builder.mutation({
      query: (payload) => {
        const { ticketId, ...body } = payload;

        return {
          url: `${TICKET_BASE_URL}/${ticketId}/responses`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (result, error, { _id }) => [
        { type: "Ticket", id: _id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    // client's transactions
    getTicketsByClient: builder.query({
      query: ({ client, ...params }) => ({
        url: `${TICKET_BASE_URL}/clients/${client}`,
        params,
      }),
      providesTags: (result, error, _id) => [
        { type: "Ticket", id: _id },
        { type: "Ticket", id: "LIST" },
      ],
    }),

    getVendorCODRequestTicket: builder.query({
      query: ({ vendorId, account, entity }) => ({
        url: `${TICKET_BASE_URL}/vendor/${vendorId}/cod-request`,
        params: { account, entity },
      }),
    }),
  }),
});

export const {
  useGetTicketDetailQuery,
  useGetTicketListQuery,
  useLazyGetTicketListQuery,
  useLazyGetTicketListForVendorProfileQuery,

  useCreateTicketMutation,
  useUpdateTicketMutation,

  useAddTicketResponseMutation,
  useUpdateTicketResponseMutation,

  useGetTicketsByClientQuery,
  useLazyGetTicketsByClientQuery,

  useLazyGetVendorCODRequestTicketQuery,
} = ticketApi;
